import { render } from "./EditDeliveryPlacePopup.vue?vue&type=template&id=1f43e152"
import script from "./EditDeliveryPlacePopup.vue?vue&type=script&lang=js"
export * from "./EditDeliveryPlacePopup.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__